import React from 'react'
import { formatDateTime } from '../../lib/formatDateHandler'

export default function LicencjaHeader({ licencja }) {
  return (
    <>
      {licencja && (
        <div>
          <div className="firm">{licencja.nazwaFirmy}</div>
          {licencja.system && (
            <div className="licence">
              RAKS{' '}
              {licencja.system === 'ESPR'
                ? 'e-Sprawozdania Finansowe'
                : licencja.system}
            </div>
          )}
          {licencja.system === 'ESPR' && licencja.status === '1' && (
            <div className="licence">WERSJA DEMONSTRACYJNA</div>
          )}
          {licencja.system !== 'ESPR' &&
            licencja.status !== '1' &&
            licencja.numer && (
              <div className="licence">Nr licencji: {licencja.numer}</div>
            )}
          {licencja.dataWaznosciSesji && (
            <div className="licence">
              Data ważności sesji: {formatDateTime(licencja.dataWaznosciSesji)}
            </div>
          )}
        </div>
      )}
      <p className="raks">raks</p>
    </>
  )
}
